import { api } from "data";
import { baseApiClient } from "data/modules/api/api.client";

// fetches creator's custom domains
export const getDomainDetails = () =>
  baseApiClient({ url: api.get_custom_domain });
